<template>
    <div class="cooperation-title-cp-container" :style="{background:bg?'#fff':'transparent'}">
        <span class="start-icon" v-if="headIcon"></span>
        <span class="title-text" :class="headIcon?'':'title-text-little'">{{title}}</span>
        <div class="toolbar">
            <div v-if="type === 'checkMore'" @click="checkMoreClick">
                <span>查看更多</span>
                <van-icon name="arrow"/>
            </div>
            <div v-if="type === 'choose'">
                <div class="search-btn-item" :class="active==='累计'?'active':''" @click="chooseClick('累计')" >累计</div>
                <div class="search-btn-item" :class="active==='本月'?'active':''" @click="chooseClick('本月')">本月</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Icon } from 'vant'
    export default {

        name: "cooperation-title-cp",
        props:{
            title:{
                type:String,
                default:()=>'变更概述'
            },
            type:{
                type:String,
                default:()=>''
            },
            headIcon:{
                type:Boolean,
                default:()=>true
            },
            bg:{
                type:Boolean,
                default:true
            }
        },
        data() {
            return {
                active:'累计'
            }
        },
        mounted() {

        },

        components: {
            'van-icon':Icon,
        },

        methods: {
            chooseClick(val){
                if(this.active === val) return
                this.active = val
                this.$emit('chooseAllOrMonth', this.active,this.type)
            },
            checkMoreClick(){
                this.$emit('checkMore', this.type)
            }
        }

    }
</script>

<style scoped lang="scss">
    .cooperation-title-cp-container {
        height: 88px;
        width: 100%;
        background: white;
        position: relative;
        line-height: 88px;
        padding-left: 30px;
        border-bottom: 1px solid #F2F2F2;
        .start-icon{
            width:11px;
            height:32px;
            background:rgba(54,196,144,1);
            position: absolute;
            left: 0;
            top: calc(50% - 16px);
        }
        .title-text{
            font-size: 32px;
            color:rgba(0,0,0,1);
        }
        .title-text-little{
            font-size: 28px;
        }
        .toolbar{
            float: right;
            color: #999999;
            font-size: 26px;
            margin-right: 40px;
                .search-btn-item{
                    width: 86px;
                    margin-top: 25px;
                    line-height: 40px;
                    border:1px solid rgba(224,224,224,1);
                    text-align: center;
                    color: #8F8F8F;
                    float: left;
                    height: 40px;
                }
                .search-btn-item:nth-child(1){
                    border-radius:8px 0px 0px 8px;
                    border-right: none;
                }
                .search-btn-item:nth-child(2){
                    margin-left: 0px;
                    border-left: none;
                    border-radius:0px 8px 8px 0px;
                }
                .active{
                    background:#36C490;
                    color: white;
                    border: 1px solid #36C490;
                }
        }
    }
</style>
<style lang="scss">
    .cooperation-title-cp-container {
        .toolbar{
            .van-icon {
                color: #858489;
                float: right;
                margin-top: 28px;
            }
        }
    }
</style>